import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function LeavePage({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <LeavePage.Outline {...props} />
  ) : (
    <LeavePage.Solid {...props} />
  );
}

LeavePage.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3.75C5.65279 3.75 3.75 5.65279 3.75 8V16C3.75 18.3472 5.65279 20.25 8 20.25H16C18.3472 20.25 20.25 18.3472 20.25 16V14C20.25 13.5858 20.5858 13.25 21 13.25C21.4142 13.25 21.75 13.5858 21.75 14V16C21.75 19.1756 19.1756 21.75 16 21.75H8C4.82436 21.75 2.25 19.1756 2.25 16V8C2.25 4.82436 4.82436 2.25 8 2.25H10C10.4142 2.25 10.75 2.58579 10.75 3C10.75 3.41421 10.4142 3.75 10 3.75H8ZM14.25 2.25H21C21.4142 2.25 21.75 2.58579 21.75 3V9.75C21.75 10.1642 21.4142 10.5 21 10.5C20.5858 10.5 20.25 10.1642 20.25 9.75V4.81066L14.0303 11.0303C13.7374 11.3232 13.2626 11.3232 12.9697 11.0303C12.6768 10.7374 12.6768 10.2626 12.9697 9.96967L19.1893 3.75H14.25C13.8358 3.75 13.5 3.41421 13.5 3C13.5 2.58579 13.8358 2.25 14.25 2.25Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

LeavePage.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
